<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              required: true,
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.Image({
              label: 'Grafika desktop',
              modelPath: [this, 'form', 'desktop_image'],
              required: true,
              help: 'Szerokość 1456px'
            }),
            new fields.Input({
              label: 'Mapa desktop',
              type: 'textarea',
              modelPath: [this, 'form', 'desktop_map']
            }),
            new fields.Image({
              label: 'Grafika tablet',
              modelPath: [this, 'form', 'tablet_image'],
              required: true,
              help: 'Szerokość 1432px'
            }),
            new fields.Input({
              label: 'Mapa tablet',
              type: 'textarea',
              modelPath: [this, 'form', 'tablet_map']
            }),
            new fields.Image({
              label: 'Grafika mobile',
              modelPath: [this, 'form', 'mobile_image'],
              required: true,
              help: 'Szerokość 960px'
            }),
            new fields.Input({
              label: 'Mapa mobile',
              type: 'textarea',
              modelPath: [this, 'form', 'mobile_map']
            })
          ]
        }
      ]
    }
  }
}
</script>
